import { c as _c } from "react/compiler-runtime";
import type { JourneyTimesProps } from './JourneyTimes.types';
const JourneyTimes = t0 => {
  const $ = _c(32);
  const {
    arrivalTime,
    departureTime,
    destination,
    endDate,
    origin,
    startDate,
    isDateShowing
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="rounded-full z-10 w-[14px] h-[14px] bg-primary-500 border-primary-400 border-2" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== departureTime) {
    t2 = departureTime && <strong className="font-bold">{departureTime}</strong>;
    $[1] = departureTime;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== origin) {
    t3 = origin && <span className="pl-2 whitespace-nowrap">{origin}</span>;
    $[3] = origin;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex items-center gap-2">{t1}{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isDateShowing || $[9] !== startDate) {
    t5 = isDateShowing && startDate && <span className="px-2 text-sm">{startDate}</span>;
    $[8] = isDateShowing;
    $[9] = startDate;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex items-center justify-between gap-2 typography-body-1">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="rounded-full z-10 w-[14px] h-[14px] bg-primary-500 border-primary-400 border-2" />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== arrivalTime) {
    t8 = arrivalTime && <strong className="font-bold">{arrivalTime}</strong>;
    $[15] = arrivalTime;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== destination) {
    t9 = destination && <span className="pl-2 whitespace-nowrap">{destination}</span>;
    $[17] = destination;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="flex items-center gap-2">{t7}{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== endDate || $[23] !== isDateShowing) {
    t11 = isDateShowing && endDate && <span className="px-2 text-sm">{endDate}</span>;
    $[22] = endDate;
    $[23] = isDateShowing;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = <div className="flex items-center justify-between gap-2 typography-body-1">{t10}{t11}</div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div aria-hidden={true} className="absolute border-r-2 border-black border-dashed inset-y-2 left-[6px]" />;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t6) {
    t14 = <div className="flex flex-col py-8px print:break-inside-avoid"><div className="relative grid gap-3">{t6}{t12}{t13}</div></div>;
    $[29] = t12;
    $[30] = t6;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
};
export { JourneyTimes };